import styled from 'styled-components';
import { rem } from 'polished';
import ProgressBar from '../ProgressBar';
import Caption from '../Caption';
import Button from '../Button';
var LoadMore = styled.div.withConfig({
  displayName: "LoadMorestyles__LoadMore",
  componentId: "sc-5sph4b-0"
})(["display:flex;align-items:center;flex-direction:column;"]);
var LoadMoreLabel = styled(Caption).attrs({
  isSecondary: true
}).withConfig({
  displayName: "LoadMorestyles__LoadMoreLabel",
  componentId: "sc-5sph4b-1"
})(["padding-bottom:16px;"]);
var LoadMoreProgress = styled(ProgressBar).withConfig({
  displayName: "LoadMorestyles__LoadMoreProgress",
  componentId: "sc-5sph4b-2"
})(["max-width:", ";margin-bottom:16px;"], rem(200));
var LoadMoreContainer = styled.div.withConfig({
  displayName: "LoadMorestyles__LoadMoreContainer",
  componentId: "sc-5sph4b-3"
})(["display:flex;justify-content:center;"]);
var LoadMoreButton = styled(Button).attrs({
  variant: 'tertiary',
  size: 'small',
  iconRight: 'refresh'
}).withConfig({
  displayName: "LoadMorestyles__LoadMoreButton",
  componentId: "sc-5sph4b-4"
})([""]);
export var Styled = {
  LoadMore: LoadMore,
  LoadMoreLabel: LoadMoreLabel,
  LoadMoreContainer: LoadMoreContainer,
  LoadMoreButton: LoadMoreButton,
  LoadMoreProgress: LoadMoreProgress
};